import React, { useCallback } from 'react';

import { useIntl } from 'react-intl';

import { CountryDropdown } from '../../country-dropdown';
import { FIELD_NAMES } from '../constants';
import { useAddressField, useAddressFormContext } from '../context';

import style from '../../dropdown-style.module.less';

export const CountryField = () => {
  const intl = useIntl();
  const { disabled } = useAddressFormContext();
  const { value, onChange, error, labelDescriptor, onBlur, trackInputClick } = useAddressField(FIELD_NAMES.COUNTRY_CODE);

  const onClick = useCallback(() => trackInputClick('country'), [trackInputClick]);

  return (
    <CountryDropdown
      disabled={disabled}
      hasError={!!error}
      label={intl.formatMessage(labelDescriptor)}
      labelClassName={style['country-label']}
      name={FIELD_NAMES.COUNTRY_CODE}
      onBlur={onBlur}
      onChange={onChange}
      onClick={onClick}
      value={value}
    />
  );
};
